import Vue from 'vue'
import VueI18n from 'vue-i18n'
// en
import enUS from 'vant/es/locale/lang/en-US'
import en from './en'
// zh
import zhCN from 'vant/es/locale/lang/zh-CN'
import zh from './zh'
import { Locale } from 'vant'

Vue.use(VueI18n)

const DEFAULT_LANG = 'zh'
const LOCALE_KEY = 'localeLanguage'

const locales = { zh, en }

const lang = process.env.VUE_APP_LANG || DEFAULT_LANG

Vue.prototype.$en = lang === 'en'

window.localStorage.setItem(LOCALE_KEY, lang)

Object.keys(locales).forEach(lang => {
  document.body.classList.remove(`lang-${lang}`)
})

document.body.classList.add(`lang-${lang}`)

document.body.setAttribute('lang', lang)

Vue.config.lang = lang

const i18n = new VueI18n({
  locale: lang,
  messages: locales,
  silentTranslationWarn: true
})

switch (lang) {
  case 'zh':
    Locale.use('zhCN', zhCN)
    break
  case 'en':
    Locale.use('en', enUS)
    break
}

i18n.locale = lang

window.i18n = i18n

export default i18n
